import { Contacts } from './contacts.model';
import { Files } from './file.model';
import { Notes } from './notes.model';

export class Partners {
    id: string;
    companyName: string;
    contactLastName: string;
    contactFirstName: string;
    email: string;
    phone: string;
    reason: string;
    goals: string;
    dateSubmitted: Date;
    contacts: Contacts[];
    notes: Notes[];
    files: Files[];

    constructor() {
        this.id = '';
        this.companyName = '';
        this.contactLastName = '';
        this.contactFirstName = '';
        this.email = '';
        this.phone = '';
        this.reason = '';
        this.goals = '';
        this.dateSubmitted = null;
        this.contacts = [];
        this.notes = [];
        this.files = [];
    }
}